import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useRole } from "../context/RoleContext";
import { useAlert } from "../context/AlertContext";

const SuperAdminRoute: React.FC = () => {
  const { isSuperAdmin } = useRole();
  const { setAlert } = useAlert();
  const shouldRedirect = !isSuperAdmin;

  React.useEffect(() => {
    if (shouldRedirect) {
      setAlert("error", "You don't have permission to access this page.");
    }
  }, [shouldRedirect]); // eslint-disable-line react-hooks/exhaustive-deps

  if (shouldRedirect) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
};

export default SuperAdminRoute;
